export function createPageUrl(pageName: string): string {
  // Simple implementation - you can modify this based on your routing needs
  switch (pageName) {
    case "Home":
      return "/";
    case "ForMe":
      return "/for-me";
    case "ForMyClients":
      return "/for-my-clients";
    case "Downloads":
      return "/downloads";
    default:
      return "/";
  }
}

// Google Ads Conversion Tracking
declare global {
  interface Window {
    gtag?: (...args: any[]) => void;
  }
}

export function trackGoogleAdsConversion(conversionLabel: string) {
  if (typeof window.gtag === 'function') {
    window.gtag('event', 'conversion', {
      'send_to': `AW-17630561846/${conversionLabel}`
    });
  }
}

// Google Analytics 4 Custom Events
export function trackGA4Event(eventName: string, parameters?: Record<string, any>) {
  if (typeof window.gtag === 'function') {
    window.gtag('event', eventName, parameters);
  }
}

// Specific tracking functions for business actions
export function trackOnboardingBooking() {
  trackGA4Event('onboarding_booking', {
    event_category: 'engagement',
    event_label: 'calendar_click',
    value: 1
  });
}

export function trackAppDownload(platform: string) {
  trackGA4Event('app_download', {
    event_category: 'conversion',
    event_label: platform,
    platform: platform,
    value: 1
  });
}

// Conversion labels - Replace these with your actual labels from Google Ads
export const CONVERSION_LABELS = {
  ONBOARDING_BOOKING: 'vMfECKKwnbEbELaM9NZB',
  IOS_DOWNLOAD: 'N_s-CIe9mrEbELaM9NZB',
  ANDROID_DOWNLOAD: 'xCaMCIq9mrEbELaM9NZB',
  MAC_DOWNLOAD: 'QlZRCI29mrEbELaM9NZB',
}; 